/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route_details__expense_note_section__edit__additional_data = /** @type {(inputs: {}) => string} */ () => {
	return `Weitere Informationen`
};

const en_route_details__expense_note_section__edit__additional_data = /** @type {(inputs: {}) => string} */ () => {
	return `Additional data`
};

const es_route_details__expense_note_section__edit__additional_data = /** @type {(inputs: {}) => string} */ () => {
	return `Información complementaria`
};

const fr_route_details__expense_note_section__edit__additional_data = /** @type {(inputs: {}) => string} */ () => {
	return `Informations complémentaires`
};

const it_route_details__expense_note_section__edit__additional_data = /** @type {(inputs: {}) => string} */ () => {
	return `Ulteriori informazioni`
};

const nl_route_details__expense_note_section__edit__additional_data = /** @type {(inputs: {}) => string} */ () => {
	return `Aanvullende informatie`
};

const pt_route_details__expense_note_section__edit__additional_data = /** @type {(inputs: {}) => string} */ () => {
	return `Informações adicionais`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__additional_data = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route_details__expense_note_section__edit__additional_data(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route_details__expense_note_section__edit__additional_data", locale)
	if (locale === "de") return de_route_details__expense_note_section__edit__additional_data(inputs)
	if (locale === "en") return en_route_details__expense_note_section__edit__additional_data(inputs)
	if (locale === "es") return es_route_details__expense_note_section__edit__additional_data(inputs)
	if (locale === "fr") return fr_route_details__expense_note_section__edit__additional_data(inputs)
	if (locale === "it") return it_route_details__expense_note_section__edit__additional_data(inputs)
	if (locale === "nl") return nl_route_details__expense_note_section__edit__additional_data(inputs)
	return pt_route_details__expense_note_section__edit__additional_data(inputs)
};